import { toJSON } from "@models/utils";
import { isEmpty } from "lodash";
export var TicketID;
(function (TicketID) {
    TicketID["FULL"] = "astra-full";
    TicketID["CORPORATE"] = "astra-corporate";
    TicketID["FOUNDING"] = "astra-founding";
})(TicketID || (TicketID = {}));
export class Ticket {
    // if 1, then metadata template id = ticketId,
    // if > 1, then '<ticketId>-<<# of nft transfer> mod <uniqueNFT>>',
    // eg. uniqueNFT = 2, metadata template id loops 'tbw-general-0','tbw-general-1'
    constructor(params) {
        this.id = params.id;
        this.defaultPrice = params.defaultPrice;
        this.prices = params.prices || {};
        this.total = params.total;
        this.sold = params.sold || 0;
        this.name = params.name || "";
        this.contractId = params.contractId || "";
        this.displayOrder = params.displayOrder;
        this.uniqueNFT = params.uniqueNFT || 1;
        this.redeemOnly = !!params.redeemOnly;
    }
    get json() {
        return toJSON(this);
    }
    get currentPrice() {
        if (isEmpty(this.prices))
            return this.defaultPrice;
        const now = new Date().valueOf();
        for (const priceId of Object.keys(this.prices)) {
            const price = this.prices[priceId];
            if (price.start <= now && price.end > now) {
                return price.max
                    ? price.sold < price.max
                        ? price.price
                        : price.fallbackPrice || this.defaultPrice
                    : price.price;
            }
        }
        return this.defaultPrice;
    }
    get remaining() {
        const allRemaining = this.total - this.sold;
        if (isEmpty(this.prices))
            return allRemaining;
        const now = new Date().valueOf();
        for (const priceId of Object.keys(this.prices)) {
            const price = this.prices[priceId];
            if (price.start <= now && price.end > now) {
                return price.max
                    ? price.sold < price.max
                        ? price.max - price.sold
                        : allRemaining
                    : allRemaining;
            }
        }
        return allRemaining;
    }
    get defaultPriceId() {
        return Object.keys(this.prices).find((priceId) => this.prices[priceId].price === this.defaultPrice);
    }
    get currentPriceId() {
        if (isEmpty(this.prices))
            return this.defaultPriceId;
        const now = new Date().valueOf();
        for (const priceId of Object.keys(this.prices)) {
            const price = this.prices[priceId];
            if (price.start <= now && price.end > now) {
                return price.max
                    ? price.sold < price.max
                        ? price.id
                        : price.id || this.defaultPriceId
                    : price.id;
            }
        }
        return this.defaultPriceId;
    }
    get discount() {
        return (this.defaultPrice > this.currentPrice &&
            ((this.defaultPrice - this.currentPrice) / this.defaultPrice) * 100);
    }
}
